import React, { useEffect, useState } from "react";
import GoToTop from "../GoToTop";
import { supabase } from "../supabase";

function Committee() {
  const [president, setPresident] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchpublications();
  }, []);

  const fetchpublications = async () => {
    try {
      const { data, error } = await supabase
        .from("presidents")
        .select("id, name, from_date,to_date, image_url")
        .order("from_date", { ascending: true });

      if (error) throw error;

      setPresident(data || []);
    } catch (err) {
      console.error("Error fetching publications:", err);
    } finally {
      setLoading(false);
    }
  };

  const [secretary, setSecretary] = useState([]);

  useEffect(() => {
    fetchsecretary();
  }, []);

  const fetchsecretary = async () => {
    try {
      const { data, error } = await supabase
        .from("general_secretary")
        .select("id, name, from_date,to_date, image_url")
        .order("from_date", { ascending: true });

      if (error) throw error;

      setSecretary(data || []);
    } catch (err) {
      console.error("Error fetching publications:", err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);

    const day = date.getDate();
    const suffix =
      day % 10 === 1 && day !== 11
        ? "st"
        : day % 10 === 2 && day !== 12
        ? "nd"
        : day % 10 === 3 && day !== 13
        ? "rd"
        : "th";

    const month = date.toLocaleString("en-US", { month: "long" });
    const year = date.getFullYear();

    return `${day}${suffix} ${month} ${year}`;
  };

  return (
    <>
      <GoToTop />
      <section id="portfolio" className="portfolio section">
        <div className="container section-title" data-aos="fade-up">
          <h2>Committee</h2>
          <p className="mb-0">President of KLA till date are as follows </p>
        </div>

        <div className="container mb-3">
          <table className="table table-striped ">
            <thead>
              <tr>
                <th>Sl No.</th>
                <th>Name of the President</th>
                <th>From Date</th>
                <th>To Date</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={4} className="text-center text-danger">
                    Loading...
                  </td>
                </tr>
              ) : president.length === 0 ? (
                <tr>
                  <td colSpan={4} className="text-center text-danger">
                    No data Found
                  </td>
                </tr>
              ) : (
                <>
                  {president.map((item, index) => (
                    <tr>
                      <td style={{ width: "75px" }}>{index + 1}</td>

                      <td>{item.name}</td>
                      <td>{formatDate(item.from_date)}</td>
                      <td>
                        {item.to_date != "1"
                          ? formatDate(item.to_date)
                          : "Till Now"}
                      </td>
                    </tr>
                  ))}
                </>
              )}
            </tbody>
          </table>
        </div>

        <div className="container mt-5">
          <div className="section-title" data-aos="fade-up">
            <p className="mb-0">
              General Secretary of KLA till date are as follows{" "}
            </p>
          </div>
          <table className="table table-striped mt-0">
            <thead>
              <tr>
                <th>Sl No.</th>

                <th>Name of the Gen. Secretary</th>
                <th>From Date</th>
                <th>To Date</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={4} className="text-center text-danger">
                    Loading...
                  </td>
                </tr>
              ) : secretary.length === 0 ? (
                <tr>
                  <td colSpan={4} className="text-center text-danger">
                    No data Found
                  </td>
                </tr>
              ) : (
                <>
                  {secretary.map((item, index) => (
                    <tr>
                      <td style={{ width: "75px" }}>{index + 1}</td>

                      <td>{item.name}</td>
                      <td>{formatDate(item.from_date)}</td>
                      <td>
                        {item.to_date != "1"
                          ? formatDate(item.to_date)
                          : "Till Now"}
                      </td>
                    </tr>
                  ))}
                </>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
}

export default Committee;
